
// import { orderPay } from '@/api'
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    goods_id: {
      type: String,
      default: ""
    },
    store_coupon_list: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      flag: false
    }
  },
  watch: {
    dialogVisible (val) {
      this.flag = val
    }
  },
  methods: {
    handleClose (done) {
      this.$emit('onDone') // 通知父组件关闭弹窗
      done()
    },
    handleClosey () {
      this.$emit('onDone')
    },
    open (coupon_id, i) {
      // 领取优惠券
      this.$confirm('Claim coupon?', 'Please confirm', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'success'
      }).then(() => {
        let { data, code, msg } = this.$api.auyFun.RECETIVE(coupon_id)
        if (data.code == 200) {
          this.$set(this.store_coupon_list[i], 'is_receive', 1)
          this.$message.success(data.msg)
        }
        // orderPay
        //   .RECETIVE({
        //     coupon_id
        //   })
        //   .then((res) => {
        //     if (res.code == 200) {
        //       this.$set(this.store_coupon_list[i], 'is_receive', 1)
        //       this.$message.success(res.msg)
        //     }
        //   })
      })
    }
  }
}
